import { NextPage } from 'next';
import React from 'react';
import FdrPageComponentsWithRequestButton from 'components/domain/fdr-page-components/fdr-page-components-with-request-button';
import {
  fdrThemeOverviewPageComponentsVars,
  fdrThemeOverviewPageVars,
} from 'components/page/theme/theme-overview.vars';
import { useFdrThemeOverviewContentQuery } from 'schemas/query/theme/fdr-theme-overview-content.generated';
import { useFdrThemeOverviewPageComponentQuery } from 'schemas/query/theme/fdr-theme-overview-page-components.generated';

export { getServerSideProps } from 'components/page/theme/theme-overview.gssp';

const THEME_OVERVIEW_REQUEST_BUTTON_BG_COLOR = '#7A2739';

const ThemeOverviewPage: NextPage = () => {
  const { data } = useFdrThemeOverviewContentQuery({
    variables: fdrThemeOverviewPageVars,
  });

  const { data: pageComponents } = useFdrThemeOverviewPageComponentQuery({
    variables: fdrThemeOverviewPageComponentsVars,
  });

  return (
    <FdrPageComponentsWithRequestButton
      components={
        pageComponents?.fdrThemeOverviewPage?.pageComponents.components
      }
      requestButton={data.fdrThemeOverviewPage?.requestButton}
      requestButtonBgColor={THEME_OVERVIEW_REQUEST_BUTTON_BG_COLOR}
    />
  );
};

export default ThemeOverviewPage;
